(() => {
  const form = document.getElementById('ContactFooterInline');
  if (!form || form.dataset.ajaxReady === 'true') return;
  form.dataset.ajaxReady = 'true';

  const feedback = form.querySelector('.fc-form-feedback');
  const button = form.querySelector('[type="submit"]');
  const buttonLabel = button.textContent;
  const successText = feedback.dataset.successMessage;
  const errorText = 'We could not send your message. Please try again.';

  const setSending = (sending) => {
    button.disabled = sending;
    button.textContent = sending ? 'Sending…' : buttonLabel;
  };

  let inFlight = false;

  const send = async () => {
    inFlight = true;
    setSending(true);
    feedback.hidden = true;

    try {
      // Shopify only redirects once the message is accepted, so don't follow the redirect.
      const response = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        redirect: 'manual',
        headers: { Accept: 'text/html' },
      });

      let failed = false;
      let message = successText;

      if (response.type !== 'opaqueredirect') {
        // No redirect: Shopify re-rendered the form with errors or rejected the request.
        const result = new DOMParser().parseFromString(await response.text(), 'text/html');
        const error = result.getElementById(form.id)?.querySelector('.fc-form-error');
        failed = true;
        message = error?.textContent.trim() || errorText;
      }

      feedback.textContent = message;
      feedback.className = `fc-form-feedback ${failed ? 'fc-form-error' : 'fc-form-success'}`;
      if (!failed) form.reset();
    } catch (error) {
      console.error('Footer contact form:', error);
      feedback.textContent = errorText;
      feedback.className = 'fc-form-feedback fc-form-error';
    } finally {
      feedback.hidden = false;
      inFlight = false;
      setSending(false);
      feedback.focus();
    }
  };

  // Shopify's hCaptcha intercepts the submit, adds its token to the form, then calls
  // form.submit() – which it reads from the form when it binds. Pointing that at our
  // AJAX sender keeps the token and avoids a full page reload.
  form.submit = send;

  // Shopify only binds hCaptcha when a field gets focus, so an autofilled form can be
  // submitted before it's ready. Start the binding if needed and wait for it.
  const whenCaptchaReady = () => new Promise((resolve) => {
    const isBound = () => form.hasAttribute('data-hcaptcha-bound');
    if (isBound() || !window.Shopify?.captcha) return resolve(isBound());
    if (!form.dataset.cptcha) window.Shopify.captcha.protect(form);

    const done = (bound) => { observer.disconnect(); clearTimeout(timer); resolve(bound); };
    const observer = new MutationObserver(() => { if (isBound()) done(true); });
    observer.observe(form, { attributes: true, attributeFilter: ['data-hcaptcha-bound'] });
    const timer = setTimeout(() => done(isBound()), 5000);
  });

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    setSending(true);
    if (form.hasAttribute('data-hcaptcha-bound')) {
      // hCaptcha will call form.submit() once it has a token
      // Re-enable the button if the captcha never completes (e.g. the challenge was closed)
      setTimeout(() => { if (!inFlight) setSending(false); }, 15000);
      return;
    }
    // Once bound, resubmit so hCaptcha's own submit listener adds the token
    if (await whenCaptchaReady()) {
      form.requestSubmit();
      return;
    }
    send();
  });
})();
